import React from "react";
import { Container, Desc, Icons, Title, Wrapper } from "./style";

export default function Services() {
  return (
    <Container title reveal>
      <Title main>My Services</Title>
      <Title main range />
      <Desc desc>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nobis minus aspernatur quam
        similique rerum facilis non maxime, nihil molestiae eaque? Voluptatum, ipsa minus
        perspiciatis quam at sint atque sequi illo rerum dolor repellendus doloribus magnam veniam
        corporis labore distinctio ut perferendis inventore fuga architecto ea!Lorem ipsum dolor,
        sit amet consectetur adipisicing elit. Nobis minus aspernatur quam similique rerum facilis
        non maxime, nihil molestiae eaque? Voluptatum, ipsa minus perspiciatis quam at sint atque
        sequi illo rerum dolor repellendus doloribus magnam veniam corporis labore distinctio ut
        perferendis inventore fuga architecto ea!
      </Desc>
      <Wrapper content>
        <Wrapper card reveal>
          <Wrapper icons>
            <Icons.Palette />
          </Wrapper>
          <Wrapper info>
            <Title info>Web Design</Title>
            <Desc>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis a vitae
              voluptates velit sint, quis rem quidem iure aliquam quasi.
            </Desc>
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper icons>
            <Icons.CodeBlock />
          </Wrapper>
          <Wrapper info>
            <Title info>Web Developer</Title>
            <Desc>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis a vitae
              voluptates velit sint, quis rem quidem iure aliquam quasi.
            </Desc>
          </Wrapper>
        </Wrapper>
        <Wrapper card reveal>
          <Wrapper icons>
            <Icons.ObjectGroup />
          </Wrapper>
          <Wrapper info>
            <Title info>Youtuber</Title>
            <Desc>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis a vitae
              voluptates velit sint, quis rem quidem iure aliquam quasi.
            </Desc>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    </Container>
  );
}
